import { Platform, Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { Stack } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { Link, Redirect, Tabs, RelativePathString, usePathname, useRouter } from 'expo-router';
import { Button } from 'react95-native-rabbl';
import { Image } from 'expo-image';
import { AppText } from '@/components/AppText';
import DrawerButton from '@/components/DrawerButton';
import { HeaderLeft } from '@/components/HeaderLeft';

const styles = StyleSheet.create({
  image28x28: {
    width: 28,
    height: 28,
    marginHorizontal: 10, 
  },
  headerIcon: {
    width: 28,
    height: 28,
    marginLeft: 15,
    marginRight: 10,
  },
});

export default function StackedPublic() {
  return (
    <Stack
      screenOptions={{
        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },

        headerTitle: (props) => <AppText {...props} style={CustomTextStyles.headerTitle} />,

        headerLeft: () => <HeaderLeft />,

        headerRight: () => <DrawerButton />,

        animation: 'none',
      }}
    >
      <Stack.Screen name="contact" options={{ title: 'Contact Us' }} />
      <Stack.Screen name="deletedata" options={{ title: 'Delete data' }} />
      <Stack.Screen name="deleteaccount" options={{ title: 'Delete account' }} />
      <Stack.Screen name="unsubscribe" options={{ title: 'Unsubscribe' }} />
      <Stack.Screen name="subscriptions" options={{ title: 'Manage subscriptions' }} />
      <Stack.Screen name="faqs" options={{ title: 'FAQs' }} />
      <Stack.Screen name="terms" options={{ title: 'Terms' }} />
      <Stack.Screen name="privacy" options={{ title: 'Privacy Policy' }} />
      <Stack.Screen name="diagnostics" options={{ title: 'Diagnostics' }} />
      <Stack.Screen name="testcomponents" options={{ title: 'Test', gestureEnabled: false }} />
      <Stack.Screen name="error" options={{ title: 'Error', headerShown: false }} />
      <Stack.Screen name="aesthetic" options={{ title: 'Aesthetic' }} />
      <Stack.Screen name="policies" options={{ title: 'Policies' }} />
      <Stack.Screen name="dataprocessing" options={{ title: 'Data Processing Agreement' }} />
      <Stack.Screen name="refunds" options={{ title: 'Refunds' }} />
      <Stack.Screen name="guidelines" options={{ title: 'Community Guidelines' }} />
      <Stack.Screen name="csae" options={{ title: 'CSAE Policy' }} />
      <Stack.Screen name="loggedout" options={{ title: 'Logged Out' }} />
      <Stack.Screen name="joinapple" options={{ title: 'Join Apple' }} />
      <Stack.Screen name="joinappleconfirm" options={{ title: 'Join Apple' }} />
      <Stack.Screen name="screenshots" options={{ title: 'Screenshots' }} />
      <Stack.Screen name="human_trafficking" options={{ title: 'Human Trafficking' }} />
      <Stack.Screen name="complaints" options={{ title: 'Complaints Policy' }} />
      <Stack.Screen name="appeals" options={{ title: 'Appeals' }} />
      <Stack.Screen name="signin" options={{ title: 'Login' }} />
      <Stack.Screen name="signout" options={{ title: 'Logout' }} />
      <Stack.Screen name="signup" options={{ title: 'Create account' }} />
      <Stack.Screen name="forgotpassword" options={{ title: 'Forgot Password' }} />
      <Stack.Screen name="resetpassword" options={{ title: 'Reset Password' }} />
      <Stack.Screen name="tests" options={{ headerShown: false }} />
    </Stack>
  );
}
